module.exports = __webpack_public_path__ + "static/img/jp.cf7f0543.svg";